import React, { useState, useEffect } from 'react';
import useForm from 'react-hook-form';
import axios from 'axios';
import Spinner from '../Spinner';

export default function Cargaproyectos() { 

	document.title = "Hackaton 3d :: Carga tu proyecto";

	useEffect(() => {
		window.callJquery();
	},[]);

	const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	const API_BASE = "https://www.ies21.edu.ar/hackaton3d/";

	const [message, setMessage] = useState("");
	const [uploadPercentage, setUploadPercentage] = useState(0);

	const [errorserver, setErrorserver] = useState(true);

	const [filename, setFilename] = useState("Ningún archivo seleccionado");
	const [imagenname, setImagenname] = useState("Ninguna imagen seleccionada");

	const [cargando, setCargando] = useState(false);

	const { register, errors, handleSubmit } = useForm();

	const onSubmit = async data => {

		const formData = new FormData();
		formData.append("file", data.file[0]);
		formData.append("imagen", data.imagen[0]);
		formData.append("email", data.email);
		formData.append("autores", data.autores);
		formData.append("titulo", data.titulo);
		formData.append("sugerencias_impresion", data.sugerencias);
		formData.append("descripcion", data.descripcion);

		try {
			const res = await axios.post(`${API_BASE}send-projects.php`, formData, {
				headers: {
					"Content-Type": "multipart/form-data"
				},
				onUploadProgress: progressEvent => {
					setUploadPercentage(parseInt(Math.round((progressEvent.loaded*100)/progressEvent.total)));
					setTimeout(() => setUploadPercentage(0), 5000);
				}               
			});

			console.log(res);

			setErrorserver(res.data.error);

			setMessage(res.data.message);
			setCargando(false);
		} catch(err) {
			if(err.response===undefined){
				setMessage("Ocurrió un problema con el servidor. Disculpe las molestias.");
			}else{
				if(err.response.status === 500) {
					setMessage("Ocurrió un problema con el servidor, no se pudo encontrar.");
				} else {
					setMessage(err.response.data.message);
				}
			}        
			setCargando(false);
			setErrorserver(true);
		} 
	}

	const onChangeFile = e => {
		setFilename(e.target.files[0].name);
	}

	const onChangeImagen = e => {
		setImagenname(e.target.files[0].name);
	}
		
	return (
		<React.Fragment>
			<h2 className="text-center mb-5 mt-5">ENVÍA TU PROYECTO</h2>

			{message !== '' ? <h2 className="text-center">{message}</h2> : null}

			{cargando ? <Spinner txt={`Un momento. Cargando datos: ${uploadPercentage}`} /> : null}

			{errorserver && !cargando ?  
				<form className="form-nobg" onSubmit={handleSubmit(onSubmit)}>
		
					<div className="form-group bmd-form-group">
						<label htmlFor="autores" className="bmd-label-floating">Autores</label>
						<input type="text" className="form-control" name="autores" id="autores" ref={register({ required: true, minlength: 4 })} />
						{errors.autores && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="email" className="bmd-label-floating">Email de contacto</label>
						<input type="email" className="form-control" name="email" id="email" ref={register({ required: true, minlength: 4, pattern: emailPattern })} />
						{errors.email && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="titulo" className="bmd-label-floating">Título del proyecto</label>
						<input type="text" className="form-control" name="titulo" id="titulo" ref={register({ required: true, minlength: 4 })} />
						{errors.titulo && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="descripcion" className="bmd-label-floating">Descripción del proyecto</label>
						<textarea className="form-control" id="descripcion" name="descripcion" rows="3" ref={register({ required: true, minlength: 4 })}></textarea>
						{errors.descripcion && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group bmd-form-group">
						<label htmlFor="sugerencias" className="bmd-label-floating">Sugerencias de impresión</label>
						<textarea className="form-control" id="sugerencias" name="sugerencias" rows="3" ref={register({ required: true, minlength: 4 })}></textarea>
						{errors.sugerencias && <small className="form-text text-muted text-error">Complete este campo</small>}
					</div>

					<div className="form-group mt-5 bmd-form-group">
						<label className="btn btn-default">
							Seleccione imagen del proyecto<input type="file" id="imagen" name="imagen" ref={register({ required: true })} onChange={onChangeImagen} hidden />
						</label>
						<span className="file">{imagenname}</span>
						{errors.imagen && <small className="form-text text-muted text-error">Seleccione un archivo</small>}
					</div>

					<div className="form-group mt-5 bmd-form-group">
						<label className="btn btn-default">
							Seleccione archivo del proyecto<input type="file" id="file" name="file" ref={register({ required: true })} onChange={onChangeFile} hidden />
						</label>
						<span className="file">{filename}</span>
						{errors.file && <small className="form-text text-muted text-error">Seleccione un archivo</small>}
					</div>

					<div className="form-group mt-5 bmd-form-group">
						<input type="submit" className="btn btn-primary" value="Enviar" />
					</div>

				</form>

			: null}

		</React.Fragment>

	);
}